import { useState, useEffect } from "react";
import { MINUTE } from "../../consts.js";
import exit from "../../vendor/exit.svg";
import clientExit from "../../vendor/exit-outline.svg";
import logo from "../../vendor/logo.svg";
import "./Header.css";

const Header = ({
  isAdmin,
  isClient,
  autoTurn,
  minDate,
  maxDate,
  setMinDate,
  validateMaxDate,
  showDaily,
  setShowDaily,
  handleLogout,
  clearFilter,
  filters,
  isModer,
  showResponds,
  setShowResponds,
  setDelay,
  setDelayChanged,
  setAutoTurn,
  customFunction,
}) => {
  const [resetVisible, setResetVisible] = useState(false);

  const delayCorrection = (arg) => {
    const timeArgs = arg.split(" ");
    let koef = 1;

    if (timeArgs[1].startsWith("час")) {
      koef = 60;
    }
    return +timeArgs[0] * koef * MINUTE;
  };

  function changeViewMode() {
    setShowResponds((prev) => !prev);
  }

  useEffect(() => {
    if (filters) {
      const hasActiveFilters = Object.values(filters).some(
        (filterArray) => filterArray && filterArray.length > 0
      );
      setResetVisible(hasActiveFilters);
    }
  }, [filters]);

  useEffect(() => {
    if (showResponds) {
      setResetVisible(false);
    }
  }, [showResponds]);

  const toLocalDateTimeString = (date) => {
    const d = new Date(date);
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);
  };

  const toLocalDateString = (date) => {
    return new Date(date).toISOString().split("T")[0];
  };

  const handleMinDateChange = (e) => {
    const value = e.target.value;
    setMinDate(new Date(value).getTime());
  };

  const handleMaxDateChange = (e) => {
    validateMaxDate(e.target.value);
  };

  return (
    <>
      <header className={`header ${isClient && "header_client"}`}>
        {isClient ? (
          <div
            onClick={customFunction}
            style={{
              width: "138px",
              height: "60px",
              padding: "8px 10px",
              borderRadius: "16px",
              boxSizing: "border-box",
              background: "var(--bg-color2)",
            }}
          >
            <img
              src={logo}
              alt="Логотип"
              className="icon"
              style={{
                width: "118.5px",
                height: "44px",
                marginLeft: 0,
              }}
            />
          </div>
        ) : (
          <img
            src={logo}
            alt="Логотип"
            className="icon"
            style={{
              width: "118.5px",
              height: "44px",
              marginLeft: 0,
            }}
          />
        )}
        {isClient ? null : (
          <>
            {!showResponds ? (
              <div className="header-dates">
                <label className="header_label">
                  С
                  <input
                    className="header-dates_input"
                    type={!isAdmin ? "date" : "datetime-local"}
                    value={
                      !isAdmin
                        ? toLocalDateString(minDate)
                        : toLocalDateTimeString(minDate)
                    }
                    onChange={handleMinDateChange}
                  />
                </label>

                <label className="header_label">
                  ПО
                  <input
                    className="header-dates_input"
                    type={!isAdmin ? "date" : "datetime-local"}
                    value={
                      !isAdmin
                        ? toLocalDateString(maxDate)
                        : toLocalDateTimeString(maxDate)
                    }
                    onChange={handleMaxDateChange}
                  />
                </label>
              </div>
            ) : (
              <div className="header-interval">
                <span className="header_label">{`Частота обновления:`}</span>
                <select
                  className="header-interval-select"
                  defaultValue="5 минут"
                  onChange={(e) => {
                    setDelayChanged(true);
                    setDelay(delayCorrection(e.target.value));
                  }}
                >
                  <option value="1 минута">1 минута</option>
                  <option value="3 минуты">3 минуты</option>
                  <option value="5 минут">5 минут</option>
                  <option value="10 минут">10 минут</option>
                  <option value="15 минут">15 минут</option>
                  <option value="20 минут">20 минут</option>
                  <option value="30 минут">30 минут</option>
                  <option value="45 минут">45 минут</option>
                  <option value="1 час">1 час</option>
                </select>
              </div>
            )}

            <label className="header_label header-days">
              <input
                type="checkbox"
                checked={!showResponds ? showDaily : autoTurn}
                onChange={(e) => {
                  !showResponds
                    ? setShowDaily(e.target.checked)
                    : setAutoTurn(e.target.checked);
                }}
              />
              {!showResponds ? "Включая дни" : "Автопролистывание"}
            </label>

            {isModer ? (
              <button className="Header-moder_button" onClick={changeViewMode}>
                Переключиться на {!showResponds ? "отправку" : "таблицу"}
              </button>
            ) : null}

            <button
              style={{ visibility: resetVisible ? "visible" : "hidden" }}
              onClick={() => clearFilter("all")}
            >
              Сбросить все фильтры
            </button>
          </>
        )}

        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={handleLogout}
        >
          <label
            className={`header_label ${isClient && "header_label_client"}`}
            style={{ cursor: "pointer" }}
          >
            {isClient ? "Выход" : "Выйти"}&nbsp;
          </label>
          <img
            className={`icon ${isClient && "header_icon_client"}`}
            src={isClient ? clientExit : exit}
            alt="выйти"
          />
        </div>
      </header>
    </>
  );
};

export default Header;
